import { Card, Typography, Divider, Space } from "antd";
import { MailOutlined, PhoneOutlined, UserOutlined, LinkedinOutlined } from "@ant-design/icons";
import "./ContactPage.css"; // We'll create this CSS file


const { Title, Text, Paragraph } = Typography;

const ContactPage = () => {
  return (
    <div className="contact-page-container">
      <Card className="contact-card">
        <div className="contact-header">
          <Title level={2} className="main-title">
            Contact Us
          </Title>
          <Paragraph className="welcome-text">
            We'd love to hear from you!
          </Paragraph>
        </div>

        <Paragraph className="description-text">
          Whether you have a question about our services, need assistance, or want to discuss 
          business opportunities — we're here for you.
        </Paragraph>

        <Divider className="divider" />

        <div className="contact-section">
          <Title level={4} className="section-title">
            <MailOutlined /> Get in Touch
          </Title>
          
          <Space direction="vertical" className="contact-details">
            <div className="contact-method">
              <MailOutlined className="contact-icon" />
              <Text strong>Email:</Text>
              <Text>contact@blushawk.com</Text>
            </div>
            
            <div className="contact-method">
              <PhoneOutlined className="contact-icon" />
              <Text strong>Phone:</Text>
              <Text>+91 83008 11267</Text>
            </div>
          </Space>
        </div>

        <Divider className="divider" />

        <div className="founder-section">
          <Title level={4} className="section-title">
            <UserOutlined /> Connect with Our Founder
          </Title>
          
          <Space direction="vertical" className="founder-details">
            <Text strong>Rahul P</Text>
            <Text>Founder, Blushawk</Text>
            
            <a 
              href="https://www.linkedin.com/in/rahul-prem/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="linkedin-link"
            >
              <LinkedinOutlined className="linkedin-icon" /> LinkedIn Profile
            </a>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default ContactPage;